'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function AnimationObserver() {
  const pathname = usePathname();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    // Small delay lets the new page's DOM settle before querying
    const id = setTimeout(() => {
      document
        .querySelectorAll('.animate-on-scroll:not(.visible)')
        .forEach((el) => observer.observe(el));
    }, 60);

    return () => {
      clearTimeout(id);
      observer.disconnect();
    };
  }, [pathname]);

  return null;
}
